<template>
  <svg :class="{ left }" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="13.5" stroke="currentColor" :fill="fill ? 'white' : 'none'"/>
    <path fill="currentColor" d="M14 8L12.9425 9.0575L17.1275 13.25H8V14.75H17.1275L12.9425 18.9425L14 20L20 14L14 8Z"/>
  </svg>
</template>

<script>
export default {
  name: 'ArrowRounded',
  props: {
    fill: {
      default: false,
    },
    left: {
      default: false,
    },
  },
  data: () => ({})
}
</script>

<style lang="scss" scoped>
.left {
  transform: rotate(180deg);
}
</style>
